import type { SerializedError } from '@reduxjs/toolkit';

export function getSerializedErrorMessage(error: SerializedError) {
  return error.message?.trim() || 'An unexpected error occurred';
}
